import { MONETIZE_CAROUSEL_HEADINGS } from '@components/monetize-carousel/monetize-carousel.constants';
import { PORTFOLIO_CONSTS } from '@constants/constant';
import { PORTFOLIO_CONSTS as PORTFOLIO_MODULE_CONSTS } from '@modules/edit-preference/components/portfolio/portfolio.contants';
import { PORTFOLIO_BANNER_VIEW_CONSTS } from '@modules/edit-preference/components/portfolio/components/portfolio-banner-view/portfolio-banner-view.constants';
import {
  PORTFOLIO_CTA_COLLECTION,
  PORTFOLIO_CTA_INDIVIDUAL,
  PORTFOLIO_SHARE_LABELS
} from '@shared/components/portfolio-share-modal/constant';
import { MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const PORTFOLIO_LAYOUT_SHARED = {
  HEADING_POSITION_LEFT: 'left',
  HEADING_POSITION_CENTER: 'center',
  HEADING_POSITION_RIGHT: 'right',
  INFO_HEADING_HIGHLIGHT: MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE,
  PORTFOLIO_TAG: 'PORTFOLIO',
  LOADING: PORTFOLIO_SHARE_LABELS.LOADING,
  READ_MORE: PORTFOLIO_BANNER_VIEW_CONSTS.READ_MORE,
  VIEW_ALL: MONETIZE_CAROUSEL_HEADINGS.SEE_ALL,
  AVAILABLE_ON: 'Available on',
  DEFAULT_ALT_COVER: 'Portfolio cover',
  WATCH: PORTFOLIO_CONSTS.ACTION.WATCH,
  PLAY: PORTFOLIO_CONSTS.ACTION.PLAY,
  STREAM: PORTFOLIO_CONSTS.ACTION.STREAM,
  LISTEN: PORTFOLIO_CONSTS.ACTION.LISTEN,
  PREVIEW: PORTFOLIO_CONSTS.ACTION.PREVIEW,
  SEE_ALL: MONETIZE_CAROUSEL_HEADINGS.SEE_ALL,
  CTA_INDIVIDUAL: PORTFOLIO_CTA_INDIVIDUAL,
  CTA_COLLECTION: PORTFOLIO_CTA_COLLECTION,
  labels: {
    TITLE: 'Title',
    SECTION_HEADING: 'Heading',
    SUBHEADING: 'Subheading',
    HEADING_POSITION: 'Show Heading on',
    HEADING_POSITION_LEFT: 'Left',
    HEADING_POSITION_CENTER: 'Center',
    HEADING_POSITION_RIGHT: 'Right'
  },
  placeholders: {
    TITLE: 'Enter title',
    SECTION_HEADING: 'Enter heading',
    SUBHEADING: 'Enter subheading'
  },
  DATA_KEYS: {
    SECTION_TITLE: 'section_title',
    SECTION_HEADING: 'section_heading',
    SUBHEADING: 'subheading',
    HEADING_POSITION: 'heading_position',
    HEADING_FONT_SIZE: 'heading_font_size',
    PORTFOLIO_ITEMS: 'portfolio_items'
  },
  ITEM_VIEW_MODES: {
    ALBUM_DETAIL: 'album-detail',
    DESCRIPTION_SPLIT: 'description-split',
    DESCRIPTION_VERTICAL_CARD: 'description-vertical-card',
    DESCRIPTION_HORIZONTAL_CARD: 'description-horizontal-card',
    DESCRIPTION_SIDEBAR_LIST: 'description-sidebar-list',
    GRID_ITEM: 'grid-item'
  },
  NESTED_LIMITS: {
    SPLIT: 3,
    SIDEBAR_LIST: 3
  }
} as const;

export const PORTFOLIO_ALBUM_DETAIL_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'portfolio-album-detail-layout',
  LAYOUT_LABEL: 'Portfolio Album Detail Layout',
  LAYOUT_DESCRIPTION:
    'Full album or single item detail with cover art, description, and track list'
} as const;

export const PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'portfolio-description-split-layout',
  LAYOUT_LABEL: 'Portfolio Description Split Layout',
  LAYOUT_DESCRIPTION:
    'Album description header with split cover art and track list'
} as const;

export const PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'portfolio-description-vertical-card-layout',
  LAYOUT_LABEL: 'Portfolio Vertical Card Layout',
  LAYOUT_DESCRIPTION:
    'Description column with a large vertical portfolio card'
} as const;

export const PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'portfolio-description-horizontal-card-layout',
  LAYOUT_LABEL: 'Portfolio Horizontal Card Layout',
  LAYOUT_DESCRIPTION:
    'Description column with a wide horizontal portfolio card'
} as const;

export const PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'portfolio-description-sidebar-list-layout',
  LAYOUT_LABEL: 'Portfolio Sidebar List Layout',
  LAYOUT_DESCRIPTION:
    'Description column with a sidebar track list and view-all action'
} as const;

export const PORTFOLIO_ITEMS_GRID_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'portfolio-items-grid-layout',
  LAYOUT_LABEL: 'Portfolio Items Grid Layout',
  LAYOUT_DESCRIPTION:
    'Section heading with a responsive grid of horizontal portfolio item cards'
} as const;

export const PORTFOLIO_LAYOUT_IDS = [
  PORTFOLIO_ALBUM_DETAIL_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_SPLIT_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_VERTICAL_CARD_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_HORIZONTAL_CARD_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_DESCRIPTION_SIDEBAR_LIST_LAYOUT_CONSTANTS.LAYOUT_ID,
  PORTFOLIO_ITEMS_GRID_LAYOUT_CONSTANTS.LAYOUT_ID
] as const;

export const PORTFOLIO_CATEGORY_LABELS = {
  COLLECTION: {
    MUSIC: PORTFOLIO_MODULE_CONSTS.MUSIC_ALBUM_CATEGORY,
    PODCAST: 'Podcast/Series',
    VIDEO: 'Video/Series',
    CUSTOM: 'Custom/Collection'
  },
  INDIVIDUAL: {
    MUSIC: PORTFOLIO_MODULE_CONSTS.INDIVIDUAL_SONG_CATEGORY,
    PODCAST: 'Podcast',
    VIDEO: 'Video',
    CUSTOM: 'Custom'
  }
} as const;
